module.exports = __webpack_public_path__ + "img/complaint.ed8153aa.png";